export const CHAINS = {
  // 1: 'mainnet',
  4: 'rinkeby',
  43113: 'avaxfuji',
  43114: 'avax'
};
